import AdminLayout from "@/layouts/AdminLayout";
import { adminNav } from "@/lib/navConfig";
import { PageHeader } from "@/components/Common";
import { JobRolesManager } from "@/components/JobRolesManager";

export default function JobRoles() {
  return (
    <AdminLayout nav={adminNav} title="Job Roles">
      <PageHeader title="Job Roles & Rates" subtitle="Job titles and their default pay rates for your company" />
      <JobRolesManager />
    </AdminLayout>
  );
}
